import { render, staticRenderFns } from "./DocumentStatus.vue?vue&type=template&id=23ea962c"
import script from "./DocumentStatus.vue?vue&type=script&lang=js"
export * from "./DocumentStatus.vue?vue&type=script&lang=js"
import style0 from "./DocumentStatus.vue?vue&type=style&index=0&id=23ea962c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports